(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-rosental"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.customElements.get('rosental-gallery')) return;

  class RosentalGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rg-track]');
      if (!this.track) return;
      this.dotsWrap = this.querySelector('[data-rg-dots]');
      this.prevBtn = this.querySelector('[data-rg-prev]');
      this.nextBtn = this.querySelector('[data-rg-next]');
      this.zoomBtn = this.querySelector('[data-rg-zoom]');
      this.lightbox = this.querySelector('[data-rg-lightbox]');

      this.buildDots();
      this.buildLightboxNav(); 
      this.bind();
      this.update();
    }
    get slides() {
      return Array.from(this.track.querySelectorAll('.rg__slide')).filter((s) => s.clientWidth > 0);
    }
    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      this.dots = this.slides.map((slide, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rg__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', () => this.goTo(slide));
        this.dotsWrap.appendChild(b);
        return b;
      });
    }
    bind() {
      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { this.update(); ticking = false; });
      }, { passive: true });
      this.prevBtn && this.prevBtn.addEventListener('click', () => this.step(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.step(1));
      this.zoomBtn && this.zoomBtn.addEventListener('click', () => this.openLightbox());
      if (this.lightbox) {
        this.lightbox.addEventListener('click', (e) => {
          if (e.target === this.lightbox || e.target.closest('[data-rg-lightbox-close]')) this.closeLightbox();
        });
this._onKey = (e) => {
          if (e.key === 'Escape') this.closeLightbox();
          else if (e.key === 'ArrowLeft') this.lightboxStep(-1);
          else if (e.key === 'ArrowRight') this.lightboxStep(1);
        };      }
      this.querySelectorAll('[data-rg-play]').forEach((poster) => {
        poster.addEventListener('click', () => {
          const tpl = poster.parentElement.querySelector('.rg__media-template');
          if (tpl) { poster.replaceWith(tpl.content.cloneNode(true)); }
        });
      });
    }
    currentIndex() {
      const slides = this.slides;
      const sl = this.track.scrollLeft;
      let best = 0, min = Infinity;
      slides.forEach((s, i) => { const d = Math.abs(s.offsetLeft - this.track.offsetLeft - sl); if (d < min) { min = d; best = i; } });
      return best;
    }
    update() {
      const active = this.currentIndex();
      this.dots && this.dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
      if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.track.scrollLeft <= 2);
      if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2);
    }
    step(dir) {
      const slides = this.slides;
      const next = Math.min(Math.max(this.currentIndex() + dir, 0), slides.length - 1);
      this.goTo(slides[next]);
    }
    goTo(slide) {
      if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }
    scrollToMedia(mediaId) {
      const slide = this.track.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }
  buildLightboxNav() {
      if (!this.lightbox || this.lightbox.__navBuilt) return;
      this.lightbox.__navBuilt = true;
      // prev
      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'rg__lightbox-arrow rg__lightbox-arrow--prev';
      prev.setAttribute('aria-label', 'Previous');
      prev.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
      prev.addEventListener('click', (e) => { e.stopPropagation(); this.lightboxStep(-1); });
      // next
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'rg__lightbox-arrow rg__lightbox-arrow--next';
      next.setAttribute('aria-label', 'Next');
      next.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
      next.addEventListener('click', (e) => { e.stopPropagation(); this.lightboxStep(1); });
      this.lightbox.appendChild(prev);
      this.lightbox.appendChild(next);
      this.lbPrev = prev;
      this.lbNext = next;
    }
    lightboxImages() {
      // only image slides (skip video posters without zoom img)
      return this.slides.map((s) => s.querySelector('img')).filter(Boolean);
    }
    showLightboxAt(index) {
      const imgs = this.lightboxImages();
      if (!imgs.length) return;
      if (index < 0) index = 0;
      if (index > imgs.length - 1) index = imgs.length - 1;
      this.lbIndex = index;
      const img = imgs[index];
      const target = this.lightbox.querySelector('[data-rg-lightbox-img]');
      target.src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
      target.alt = img.alt || '';
      target.style.cssText = 'max-width:90vw!important;max-height:90vh!important;object-fit:contain!important;';
      // toggle arrows visibility (hide if single image)
      const many = imgs.length > 1;
      if (this.lbPrev) this.lbPrev.style.display = many ? '' : 'none';
      if (this.lbNext) this.lbNext.style.display = many ? '' : 'none';
    }
    lightboxStep(dir) {
      this.showLightboxAt((this.lbIndex || 0) + dir);
    }
    openLightbox() {
      if (!this.lightbox) return;
      const imgs = this.lightboxImages();
      if (!imgs.length) return;
      // Move lightbox to <body> so header/section stacking context can't trap it
      if (this.lightbox.parentElement !== document.body) document.body.appendChild(this.lightbox);
      this.lightbox.style.cssText =
        'position:fixed!important;top:0!important;left:0!important;right:0!important;bottom:0!important;' +
        'width:100vw!important;height:100vh!important;margin:0!important;' +
        'z-index:100001!important;background:rgba(0,0,0,0.9)!important;' +
        'display:flex!important;align-items:center!important;justify-content:center!important;padding:2rem!important;';
      this.showLightboxAt(this.currentIndex());
      this.lightbox.removeAttribute('hidden');
      document.body.classList.add('overflow-hidden');
      document.addEventListener('keydown', this._onKey);
    }
    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.setAttribute('hidden', '');
      this.lightbox.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', this._onKey);
    }

  }
  window.customElements.define('rosental-gallery', RosentalGallery);

  function initSection(root) {
    if (!root || root.__rgInit) return;
    root.__rgInit = true;

    const gallery = root.querySelector('rosental-gallery');
    const form = root.querySelector('[data-rg-form]') || root.querySelector('form.rg-form');
    const idInput = root.querySelector('[data-rg-id]');
    const priceWrap = root.querySelector('[data-rg-price]');
    const atc = root.querySelector('[data-rg-atc]');
    const atcText = root.querySelector('[data-rg-atc-text]');
    const errorEl = root.querySelector('[data-rg-error]');
    const dataEl = root.querySelector('[data-rg-variant-data]');
    let variants = {};
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}

    // -------- Variant selection --------
    function selectedValues() {
      const fieldsets = root.querySelectorAll('[data-rg-option]');
      return Array.from(fieldsets).map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(values) {
      let foundId = null;
      Object.keys(variants).forEach((id) => {
        const v = variants[id];
        if (v.options.length === values.length && v.options.every((o, i) => o === values[i])) foundId = id;
      });
      return foundId ? { id: foundId, data: variants[foundId] } : null;
    }
    function renderPrice(v) {
      if (!priceWrap) return;
      const showSavings = priceWrap.getAttribute('data-show-savings') === 'true';
      const savingsLabel = priceWrap.getAttribute('data-savings-label') || '';
      let html = '';
      if (v.on_sale) html += '<s class="rg-price__compare">' + v.compare + '</s>';
      html += '<span class="rg-price__current' + (v.on_sale ? ' is-sale' : '') + '">' + v.price + '</span>';
      if (v.on_sale && showSavings) html += '<span class="rg-savings">' + savingsLabel + ': ' + v.savings + '</span>';
      priceWrap.innerHTML = html;
    }
    function updateAvailability(v) {
      if (!atc) return;
      const add = atc.getAttribute('data-add-label');
      const sold = atc.getAttribute('data-soldout-label');
      atc.toggleAttribute('disabled', !v.available);
      if (atcText) atcText.textContent = v.available ? add : sold;
    }
    function onVariantChange() {
      const values = selectedValues();
      // update pill active styling
      root.querySelectorAll('.rg-pill').forEach((p) => {
        const inp = p.querySelector('input');
        p.classList.toggle('is-active', inp && inp.checked);
      });
      const match = findVariant(values);
      if (!match) {
        if (atc) { atc.setAttribute('disabled', ''); if (atcText) atcText.textContent = atc.getAttribute('data-soldout-label'); }
        return;
      }
      if (idInput) idInput.value = match.id;
      renderPrice(match.data);
      updateAvailability(match.data);
      if (root.__rgSyncSticky) root.__rgSyncSticky(match.data);
      if (gallery && match.data.media_id) gallery.scrollToMedia(match.data.media_id);
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    }
    root.querySelectorAll('[data-rg-opt-input]').forEach((inp) => inp.addEventListener('change', onVariantChange));

    // -------- Add to cart (AJAX, Dawn cart-drawer enhancement) --------
    if (form) {
      form.addEventListener('submit', async (e) => {
        if (!window.fetch || !window.FormData) return; // no-JS / old browser fallback: normal submit
        e.preventDefault();
        if (atc && atc.hasAttribute('disabled')) return;
        if (errorEl) { errorEl.setAttribute('hidden', ''); errorEl.textContent = ''; }
        atc && atc.classList.add('is-loading');
        var _rgSb = root.querySelector('[data-rg-sticky-atc]'); _rgSb && _rgSb.classList.add('is-loading');

        const cartDrawer = document.querySelector('cart-drawer');
        const body = new FormData(form);
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          const ids = cartDrawer.getSectionsToRender().map((s) => s.id);
          body.append('sections', ids.join(','));
          body.append('sections_url', window.location.pathname);
        }
        const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url + '.js' : '/cart/add.js';
        try {
          const res = await fetch(addUrl, { method: 'POST', headers: { Accept: 'application/javascript' }, body });
          const json = await res.json();
          if (res.status !== 200) {
            if (errorEl) { errorEl.textContent = json.description || json.message || 'Could not add to cart.'; errorEl.removeAttribute('hidden'); }
          } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            // Cart was empty before this add: <cart-drawer> still carries the
            // `is-empty` class whose CSS hides the header/items, so the drawer
            // would look blank until a refresh. Drop it before re-rendering.
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(json);
          } else {
            updateCartCount();
            flashAdded();
          }
        } catch (err) {
          form.submit();
        } finally {
          atc && atc.classList.remove('is-loading');
          var _rgSb2 = root.querySelector('[data-rg-sticky-atc]'); _rgSb2 && _rgSb2.classList.remove('is-loading');
        }
      });
    }
    function flashAdded() {
      if (!atcText) return;
      const prev = atcText.textContent;
      atcText.textContent = '✓ ' + (atc.getAttribute('data-add-label') || 'Added');
      setTimeout(() => { atcText.textContent = prev; }, 1600);
    }
    async function updateCartCount() {
      try {
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      } catch (e) {}
    }

    // -------- Read more --------
    const readmore = root.querySelector('[data-rg-readmore]');
    if (readmore) {
      readmore.addEventListener('click', () => {
        const feature = root.querySelector('[data-rg-feature]');
        const expanded = feature.classList.toggle('is-expanded');
        readmore.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        readmore.textContent = expanded ? (readmore.getAttribute('data-less') || 'Read less') : (readmore.getAttribute('data-more') || 'Read more');
      });
    }

// -------- Drawers (side panel / bottom-sheet) --------
    root.querySelectorAll('.rg-drawer').forEach((drawer) => {
      const trigger = drawer.querySelector('[data-rg-drawer-open]');
      const panel = drawer.querySelector('.rg-drawer__panel');
      const closeBtn = drawer.querySelector('[data-rg-drawer-close]');
      if (!trigger || !panel) return;

      // remove any old overlay tied to this drawer (we build a fresh full-screen one)
      const oldOverlay = drawer.querySelector('[data-rg-drawer-overlay]');
      if (oldOverlay) oldOverlay.remove();

      // Move panel to <body> so no parent stacking context traps it
      if (panel.parentElement !== document.body) document.body.appendChild(panel);
      panel.style.setProperty('z-index', '100000', 'important');

      // Build a fresh full-screen overlay on <body>
      const overlay = document.createElement('div');
      overlay.className = 'rg-drawer__overlay-js';
      overlay.style.cssText =
        'position:fixed!important;top:0!important;left:0!important;right:0!important;bottom:0!important;' +
        'width:100vw!important;height:100vh!important;margin:0!important;padding:0!important;' +
        'background:rgba(0,0,0,0.5)!important;z-index:99999!important;opacity:0;' +
        'transition:opacity 0.3s ease;pointer-events:auto;display:none;';
      document.body.appendChild(overlay);

      let onKey;
      function open() {
        drawer.classList.add('is-open');
        panel.removeAttribute('hidden');
        overlay.style.display = 'block';
        requestAnimationFrame(() => {
          drawer.classList.add('is-animating');
          panel.classList.add('is-animating');
          overlay.style.opacity = '1';
        });
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');
        onKey = (e) => {
          if (e.key === 'Escape') { e.preventDefault(); close(); return; }
          if (e.key !== 'Tab') return;
          const f = panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])');
          if (!f.length) return;
          const first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        };
        document.addEventListener('keydown', onKey);
        panel.focus();
      }
      function close() {
        drawer.classList.remove('is-animating');
        panel.classList.remove('is-animating');
        overlay.style.opacity = '0';
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', onKey);
        const done = () => { drawer.classList.remove('is-open'); panel.setAttribute('hidden', ''); overlay.style.display = 'none'; panel.removeEventListener('transitionend', done); };
        panel.addEventListener('transitionend', done);
        setTimeout(done, 400);
        trigger.focus();
      }
      trigger.addEventListener('click', open);
      closeBtn && closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', close);
    });

    // -------- Sticky add to cart --------
    const sticky = root.querySelector('[data-rg-sticky]');
    if (sticky && atc) {
      const stickyBtn = sticky.querySelector('[data-rg-sticky-atc]');
      const stickyBtnText = sticky.querySelector('[data-rg-sticky-atc-text]');
      const stickyPrice = sticky.querySelector('[data-rg-sticky-price]');
      const stickyImg = sticky.querySelector('[data-rg-sticky-img]');

      // Reveal the bar once the main Add-to-cart button scrolls out of view,
      // but hide it again as soon as the footer enters the viewport so the
      // sticky bar never overlaps the footer.
      const footerEl = document.querySelector('footer.remy-footer, .shopify-section-group-footer-group, #shopify-section-footer, footer');
      let atcOut = false, footerIn = false;
      const applyStickyState = () => { sticky.classList.toggle('is-visible', atcOut && !footerIn); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => { atcOut = !entry.isIntersecting; });
          applyStickyState();
        }, { threshold: 0 }).observe(atc);
        if (footerEl) {
          new IntersectionObserver((entries) => {
            entries.forEach((entry) => { footerIn = entry.isIntersecting; });
            applyStickyState();
          }, { threshold: 0 }).observe(footerEl);
        }
      } else {
        const onScroll = () => {
          const r = atc.getBoundingClientRect();
          atcOut = r.bottom < 0 || r.top > window.innerHeight;
          if (footerEl) {
            const fr = footerEl.getBoundingClientRect();
            footerIn = fr.top < window.innerHeight;
          }
          applyStickyState();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      // Sticky button submits the real product form (keeps AJAX cart behaviour)
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', () => {
          if (stickyBtn.hasAttribute('disabled')) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(atc);
          else atc.click();
        });
      }

      // Keep the bar's price / availability / image in sync with variant changes
      root.__rgSyncSticky = function (v) {
        if (stickyPrice) {
          let html = '';
          if (v.on_sale) html += '<s class="rg-sticky__compare">' + v.compare + '</s>';
          html += '<span class="rg-sticky__current' + (v.on_sale ? ' is-sale' : '') + '">' + v.price + '</span>';
          stickyPrice.innerHTML = html;
        }
        if (stickyBtn) {
          stickyBtn.toggleAttribute('disabled', !v.available);
          if (stickyBtnText) stickyBtnText.textContent = v.available ? atc.getAttribute('data-add-label') : atc.getAttribute('data-soldout-label');
        }
        if (stickyImg && v.media_id && gallery) {
          const slideImg = gallery.querySelector('[data-media-id="' + v.media_id + '"] img');
          if (slideImg) stickyImg.src = slideImg.currentSrc || slideImg.src;
        }
      };
    }
  }

  function initAll() { document.querySelectorAll('[data-rosental]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => { const el = e.target.querySelector('[data-rosental]'); if (el) initSection(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVT(root) {
    if (!root || root.__vtInit) return;
    root.__vtInit = true;

    var track = root.querySelector('[data-vt-track]');
    var prev = root.querySelector('[data-vt-prev]');
    var next = root.querySelector('[data-vt-next]');
    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.vt__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function updateArrows() {
      if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 2);
      if (next) next.toggleAttribute('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () {
      if (track.__raf) return;
      track.__raf = requestAnimationFrame(function () { updateArrows(); track.__raf = null; });
    }, { passive: true });
    updateArrows();
    window.addEventListener('resize', updateArrows);

    var isDown = false, startX = 0, startScroll = 0, moved = 0;
    track.addEventListener('mousedown', function (e) {
      if (e.target.closest('video, iframe')) return;
      isDown = true; moved = 0;
      startX = e.pageX; startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      moved = Math.abs(dx);
      track.scrollLeft = startScroll - dx;
    });

    function stopAllVideos(exceptCard) {
      root.querySelectorAll('[data-vt-card]').forEach(function (card) {
        if (card === exceptCard) return;
        card.classList.remove('is-playing');
        var vid = card.querySelector('video');
        if (vid) vid.pause();
        var iframe = card.querySelector('iframe');
        if (iframe && iframe.dataset.src) iframe.src = '';
      });
    }

    root.querySelectorAll('[data-vt-card]').forEach(function (card) {
      var playBtn = card.querySelector('[data-vt-play]');
      if (!playBtn) return;

      playBtn.addEventListener('click', function (e) {
        if (moved > 6) return;
        e.preventDefault();
        e.stopPropagation();

        stopAllVideos(card);
        card.classList.add('is-playing');

        var video = card.querySelector('video');
        var iframe = card.querySelector('iframe');

        if (video) {
          video.play().catch(function () {
            video.muted = true;
            video.play().catch(function () {});
          });
        } else if (iframe && iframe.dataset.src) {
          iframe.src = iframe.dataset.src;
        }
      });

      var video = card.querySelector('video');
      if (video) {
        video.addEventListener('ended', function () {
          card.classList.remove('is-playing');
        });
      }
    });
  }

  function initAll() { document.querySelectorAll('[data-vt]').forEach(initVT); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-vt]'); if (el) initVT(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
